import * as serviceWorker from './serviceWorker'
import { LicenseManager } from 'ag-grid-enterprise/main'
import App from './App'
import React from 'react'
import ReactDOM from 'react-dom'

LicenseManager.setLicenseKey(
  'Equidate_Equidate_Admin_1Devs10_April_2019__MTU1NDg1MDgwMDAwMA==a6b85892826f06d2faa18626455efb87'
)
ReactDOM.render(<App />, document.getElementById('root'))
if ((module as any).hot) {
  ;(module as any).hot.accept('./App', () => {
    const NextApp = require('./App').default
    ReactDOM.render(<NextApp />, document.getElementById('root'))
  })
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
